export const setDroneData = (
  type = "",
  droneId = "",
  status = "AVAILABLE",
  id = "",
  isUpdate = false,
  drone_ip = "",
  device_id = "",
  // base_station_ip = ""
) => ({
  type,
  droneId,
  // base_station_ip,
  status,
  id,
  isUpdate,
  drone_ip,
  device_id
});
